module.exports = __webpack_public_path__ + "media/images/products/demo/earphones-af60b83ecd63ace7cdbfaaf5e5f8f6c1.jpg";